import { render, staticRenderFns } from "./imageAndTextLeft.vue?vue&type=template&id=78b7f6be&scoped=true&"
import script from "./imageAndTextLeft.vue?vue&type=script&lang=js&"
export * from "./imageAndTextLeft.vue?vue&type=script&lang=js&"
import style0 from "./imageAndTextLeft.vue?vue&type=style&index=0&id=78b7f6be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b7f6be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VImg,VRow,VSpacer})
